import { isAutherized } from './keycloak';

import { __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL, __CANDIDATO, __DIGITADOR } from '../security/RoleConfiguration';

export default function AuthorizedFunction(roles) {
    return isAutherized(roles);
}

export const isAdministradorOuCentral = () => AuthorizedFunction([__ADMINISTRADOR, __CENTRAL]);
export const isCoordenador = () => AuthorizedFunction([__COORDENADOR]);
export const isApoioSecretarial = () => AuthorizedFunction([__APOIO_SECRETARIAL]);
export const isCoordenadorOuApoioSecretarial = () => AuthorizedFunction([__COORDENADOR, __APOIO_SECRETARIAL]);
export const isCandidato = () => AuthorizedFunction([__CANDIDATO]);
export const isDigitador = () => AuthorizedFunction([__DIGITADOR]);
